const appData = {
  googleMapApiKey: "AIzaSyBjnsedFLB4nVkgtsi5nl3fMcCHxLcDMVI",
  birdsEyeView: {
    selectList: [
      { label: "ALL", value: "ALL" },
      { label: "PREGAME", value: "PREGAME" },
      { label: "IN GAME", value: "IN GAME" },
      { label: "POST GAME", value: "POST GAME" },
      { label: "EVENTS", value: "EVENTS" },
      { label: "OUTDOORS", value: "OUTDOORS" },
      { label: "CONCESSIONS", value: "CONCESSIONS" },
      { label: "TAILGATE AREA", value: "TAILGATE AREA" },
      { label: "VIP", value: "VIP" },
    ],
  },
  analytics: {
    selectList: [
      { label: "Day", value: "Day" },
      { label: "Week", value: "Week" },
      { label: "Month", value: "Month" },
      { label: "Year", value: "Year" },
    ],
  },
};
export default appData;
